import { Paper } from "../../tailwindcomponents";
import { ReactNode } from "react";
import { palette } from "../../theme/palette";

type Props = {
    children: ReactNode | Array<ReactNode>;
    historyElement?: boolean; //Determines whether to color background white og orange
}

const TicketListItem = ({ children, historyElement }: Props) => {
    return (
        <div className="w-2/3 m-2">
            <Paper variant="elevation" elevation={4} style={{ borderRadius: 32, backgroundColor: historyElement === false ? palette.secondary : palette.backgroundPaper }}>
                <div className="flex flex-wrap w-full justify-center md:justify-center lg:justify-between xl:justify-between">
                    {children}
                </div>
            </Paper>
        </div>
    );
}

export default TicketListItem;